export default __webpack_public_path__ + "static/media/Chandra.0557cf81.jpeg";